import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';


@Component({
    selector: 'app-stacked-buttons',
    templateUrl: './stacked-buttons.component.html',
    styleUrls: ['./stacked-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class StackedButtonsComponent{

  constructor(
    private _cdRef: ChangeDetectorRef,
  ) {}

}
